module.exports = __webpack_public_path__ + "static/2-19f4383d266fcac0f87c69a6e0a414c4.jpg";